<template>
<div class="detail_body">
		<!-- <v-head
		title="抬头信息"
		:sdata="sdata"></v-head> -->
  <div class="coll">
    <h2 class="title"><span>采购订单明细</span></h2>
    <tab-list :tabList="sdata" :columns="tabColumns" setHeadBtn tabName="business-sale-detail" tabHeight="500">
    </tab-list>
  </div>
</div>
</template>

<script>
import tabList from 'components/table/list.vue';
export default{
  props:{
    sdata:Array
  },
	components:{
		// vHead,
		tabList
	},
	data(){
		return{
      tabColumns:[
        {field: 'purchaseOrderNo', title: '采购订单号', width: 150,"sortable":true},
        {field: 'materialCode', title: '物料编码'},
        {field: 'materialDesc', title: '物料描述'},
        {field: 'basicUnitDesc', title: '基本单位'},
        {field: 'materialGroupDesc', title: '物料组'},
        {field: 'purchaseNum', title: '采购订单数量'},
        {field: 'removeMark', title: '删除标志'},
      ],//表头字段
		}
	},
	created(){

	},
	methods:{
	}
}
</script>

<style>
</style>
